import request from '@/utils/request'
const apiPath = '/cust_service/custServiceInfoLibraryContent'
import { downloadBlob } from '@/utils/download'
const custServiceInfoLibraryContentApi = {
  /**
   * 新增【知识库内容】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【知识库内容】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【知识库内容】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
}
export default custServiceInfoLibraryContentApi
